import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import * as React from 'react'

import Divider from '@mui/material/Divider'
import { ActionButton } from '../../common/Button'
import styles from './CustomDialog.module.css'

interface CustomDialogProps {
  open: boolean
  setClose?: () => void
  primaryAction?: () => void
  secondaryAction?: () => void
  primaryActionButtonText?: string
  secondaryActionButtonText?: string
  title: string
  children: React.ReactNode
  keepMounted?: boolean
  primaryActionDisabled?: boolean
  secondaryActionDisabled?: boolean
  disclaimer?: string
  primaryActionLarge?: boolean
  clearFilters?: () => void
  clearFiltersButtonText?: string
  fullWidth?: boolean
  isRequestDialog?: boolean
  isBoldTitle?: boolean
  hasDivider?: boolean
  isRoboto?: boolean
}

export default function CustomDialog({
  open,
  children,
  title,
  primaryAction,
  primaryActionButtonText,
  secondaryAction,
  secondaryActionButtonText,
  setClose,
  primaryActionDisabled = false,
  secondaryActionDisabled = false,
  disclaimer = '',
  primaryActionLarge = false,
  clearFilters,
  clearFiltersButtonText,
  fullWidth = false,
  isRequestDialog = false,
  isBoldTitle = false,
  hasDivider = true,
  isRoboto = false,
}: CustomDialogProps) {
  return (
    <Dialog
      onClose={setClose}
      open={open}
      maxWidth={fullWidth ? 'lg' : undefined}
      classes={{ paper: isRequestDialog ? styles.requestDialogPaper : undefined }}>
      <div className={isRequestDialog ? styles.requestDialogWrapper : styles.dialogWrapper}>
        <span className={isRequestDialog ? (isBoldTitle ? styles.boldTitle : styles.requestDialogTitle) : styles.title}>
          {title}
        </span>
        {setClose && (
          <IconButton
            aria-label="close"
            onClick={setClose}
            className={styles.closeButton}>
            <CloseIcon />
          </IconButton>
        )}

        {clearFilters && (
          <span
            className={styles.clearFilters}
            onClick={clearFilters}>
            {clearFiltersButtonText}
          </span>
        )}
        {isRequestDialog && hasDivider && <Divider className={styles.requestDialogDivider} />}

        {children}
        <DialogActions className={isRequestDialog ? styles.actionsWrapperAlignRight : styles.actionsWrapper}>
          {secondaryAction && (
            <ActionButton
              className={
                isRequestDialog
                  ? isRoboto
                    ? styles.secondaryActionButtonAlignRightRoboto
                    : styles.secondaryActionButtonAlignRight
                  : undefined
              }
              template="secondary"
              onClick={secondaryAction}
              text={secondaryActionButtonText}
              disabled={secondaryActionDisabled}
            />
          )}
          {primaryAction && (
            <div className={secondaryAction ? undefined : styles.center}>
              <ActionButton
                className={
                  isRequestDialog
                    ? isRoboto
                      ? styles.primmaryActionButtonAlignRightRoboto
                      : styles.primaryActionButtonAlignRight
                    : undefined
                }
                onClick={primaryAction}
                text={primaryActionButtonText}
                disabled={primaryActionDisabled}
                large={primaryActionLarge}
              />
            </div>
          )}
        </DialogActions>
        {disclaimer && <p className={styles.disclaimer}>{disclaimer}</p>}
      </div>
    </Dialog>
  )
}
